const state = {
  resolution: {
    height: window.screen.height,
    width: window.screen.width
  }
};

export default {
  namespaced: true,
  state
};
